<!-- Modal -->
<div class="modal-dialog modal-dialog-centered mail-modal privacy-policy-modal">
	<div class="modal-content">
		<div class="modal-body position-relative">
			<div class="text-start p-2 mail-verfication-wrap" id="step1">
				<h3 class="text-start m-0">Privacy Policy & Terms of Service Update</h3>
				<h4 class="text-start fs-6 my-4">We've Updated Our Privacy Policy and Terms of Service.</h4>

					<div class="form-group">
						<p class="text-start">Our <a rel="noopener" target="_blank"
									href="{{commonService?.docUrls?.privacy_policy_url}}">privacy policy</a>
								and
								<a target="_blank" rel="noopener"
									href="{{commonService?.docUrls?.user_agreement_url}}">terms of
									service</a> have recently
							changed. To continue using the application, please review the updated documents and provide your consent.

						</p>
						<p class="text-start">By clicking "Agree," you acknowledge that you have read and accept the new Privacy Policy and Terms of
									Service.
						</p>
					</div>
					<!-- agree button : Privacy Policy and Agreement (SIGNATURE REQUIRED) -->
					<div class="form-group mb-3">
						<div class="signature-container" *ngIf="isPendingSignature">
							<div class="alert-signature ">
								<div class="flex">
									<div class="flex-shrink-0">
										<svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
											xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 alert-svg">
											<path clip-rule="evenodd"
												d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
												fill-rule="evenodd"></path>
										</svg>
									</div>
									<div class="alert-prompt-wrap">
										<span class="text-sm text-yellow-700 blink-soft">
											A signing request is pending. Please open
											MetaMask to review
											and complete the
											process.
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex gap-3 flex-wrap"
						[ngClass]="{'justify-content-end':isCancelOption , 'justify-content-between':!isCancelOption , 'disabled':submitted}">
						<button (click)="closePrivecyModal()" type="button" class="onboard_cancel" data-bs-dismiss="modal"
							>Cancel.</button>
						<button [disabled]="submitted" type="submit" class="onboard_verify" [ngClass]="{'disabled':submitted}" (click)="triggerSignatureRetrieval()">{{submitted
							?'Processing...':'Agree'}}
						</button>
					</div>
			</div>
		</div>
	</div>
</div>